module.exports = __webpack_public_path__ + "static/portfolio_gallery_28-fd52e5bae4a88bbccd86954802d8a258.jpg";